import React, { useEffect, useState } from 'react';

function Terms() {

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `Terms | Scan360`;

    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 mb-6">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated March 22, 2026</p>

      <p className="mb-4">
        Welcome to <strong>Scan360.in</strong>. Thanks for using our products and services ("Services"). The Services are provided by <strong>Us </strong> through its network of websites and domains at scan360.in ("Site").
        By using our Services, you are agreeing to these terms. Please read them carefully.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Terms</h2>
      <p className="mb-4">
        By accessing the Site, you agree to be bound by these terms of service and all applicable laws. If you do not agree, you are prohibited from using or accessing this site.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Service License</h2>
      <p className="mb-2">You are granted a personal, non-commercial, transitory license to use the materials on the Site. This license does not permit you to:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Modify or copy the materials</li>
        <li>Use materials for commercial/public display</li>
        <li>Reverse-engineer any software</li>
        <li>Remove copyright or proprietary notices</li>
        <li>Mirror the materials on another server</li>
        <li>Use Data available in this platform for commercial purpose, without permission.</li>
      </ul>
      <p className="mb-4">
        This license terminates automatically upon any violation of these restrictions.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Disclaimer and Warranties</h2>
      <p className="mb-4">
        The materials on the Site are provided "as is". We disclaim all warranties, including implied warranties of merchantability and fitness. Content may contain errors. We make no guarantees regarding accuracy, completeness, or currentness.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Liability for our Services</h2>
      <p className="mb-4">
        <strong>We </strong> are not liable for lost profits, revenues, or data, or for indirect, special, or consequential damages. Total liability is limited to the amount you paid us to use the Services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Links</h2>
      <p className="mb-4">
        We are not responsible for content of external links. Use of linked websites is at your own risk.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Modifications</h2>
      <p className="mb-4">
        These terms may be updated from time to time. It’s your responsibility to check updates periodically. Continued use of the Site implies agreement to the updated terms.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Governing Law</h2>
      <p className="mb-4">
        These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Surat, Gujarat.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>
        For complaints or further information, please contact us at: <a href="mailto:support@scan360.in" className="text-blue-600 underline">support@scan360.in</a>
      </p>
    </div>
  );
}

export default Terms;
